export const types = {
  DISPLAY_ERROR: 'DISPLAY_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR'
}

export interface State {
  error: string | null
}